export default {
  name: 'EditReadingBulkMeter',
  props: {
    dataObj: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      appData: {},
      inputClases: []
    };
  },
  computed: {
    numOfMeters: function () {
      return this.appData.subMeters.length + 1;
    },
    connsDifference: function () {
      let sum = 0;
      this.appData.subMeters.forEach((s) => (sum = sum + Number(s.consumption)));

      let bulkCons = this.appData.bulkMeter.consumption ? Number(this.appData.bulkMeter.consumption) : 0;
      return Math.abs(sum - bulkCons);
    }
  },
  created() {
    this.appData = { ...this.dataObj };
    this.saveDataToDb();

    this.inputClases.push(''); //for bulk
    this.appData.subMeters.forEach((s) => this.inputClases.push(''));
  },
  mounted() {
    this.setConsumption();
  },
  beforeUnmount() {
    this.debounceFunc.cancel();
  },
  methods: {
    clockOver(subMeter) {
      subMeter.clockOver = !subMeter.clockOver;
      this.setConsumption();
    },
    setConsumption() {
      //sub meters
      for (let i = 0; i < this.appData.subMeters.length; i++) {
        this.dataObj.setConsumption(this.appData.subMeters[i]);
        this.inputClases[i] = this.dataObj.getInputClass(this.appData.subMeters[i]);
        this.saveDataToDb();
      }
      //for bulk
      this.dataObj.setConsumption(this.appData.bulkMeter);
      this.inputClases[this.inputClases.length] = this.dataObj.getInputClass(this.appData.bulkMeter);

      this.$forceUpdate();
    },
    clockOverClicked(meter) {
      meter.clockOver = !meter.clockOver;
      this.saveDataToDb();
    },
    saveDataToDb() {
      this.$store.commit('setCmrBulkMeter', this.appData);
    },
    getClockOverButtonClass(read) {
      if (read.clockOver === true) return 'md-primary';
      else return ' ';
    },
    infoLine2(type, idx) {
      if (type === 'bulk') {
        return `${this.$t('captureMR.ColumnPrevRdg')}: ${this.appData.bulkMeter.prRead1 ?? 0} - ${this.$t('captureMR.ColumnPrevCons')}: ${
          this.appData.bulkMeter.prCons1 ?? 0
        } / ${this.appData.bulkMeter.prCons2 ?? 0} / ${this.appData.bulkMeter.prCons3 ?? 0} / ${this.appData.bulkMeter.prCons4 ?? 0}`;
      } else {
        return `${this.$t('captureMR.ColumnPrevRdg')}: ${this.appData.subMeters[idx].prRead1 ?? 0} - ${this.$t('captureMR.ColumnPrevCons')}: ${
          this.appData.subMeters[idx].prCons1 ?? 0
        } / ${this.appData.subMeters[idx].prCons2 ?? 0} / ${this.appData.subMeters[idx].prCons3 ?? 0} / ${this.appData.subMeters[idx].prCons4 ?? 0}`;
      }
    }
  }
};
